// hooks/useUserRole.js
import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';

const useUserRole = () => {
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();

    useEffect(() => {
        const fetchRole = async () => {
            const user = auth.currentUser;
            if (user) {
                const tokenResult = await user.getIdTokenResult(true);
                setRole(tokenResult.claims.role); // 'admin' or 'superadmin'
            }
            setLoading(false);
        };

        fetchRole();
    }, []);

    return { role, loading };
};

export default useUserRole;
